import { render } from "./SocialCard.vue?vue&type=template&id=9f97d720"
import script from "./SocialCard.vue?vue&type=script&lang=js"
export * from "./SocialCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__